/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_WeightInputs */

const vi_aroma_sampling_weight = /** @type {(inputs: Aroma_Sampling_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng (kg)`)
};

/**

* @param {Aroma_Sampling_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_weight = /** @type {((inputs?: Aroma_Sampling_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_weight(inputs)
});